import { AuthService } from "@js/services/AuthService";
import { DevFinanceDealService } from "@js/services/Deal/DevFinanceDealService";
import { SharedSearchResultsService } from "@js/services/Deal/SharedSearchResultsService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { SharedDataService } from "@js/services/SharedDataService";
import { CompareResultsService } from "@js/services/CompareResultsService";
import {
  ApplicationUser,
  BrickflowEventLogClient,
  CaseLenderStateEnum,
  CaseStatusEnum,
  Client,
  DealClient,
  DealClientClient,
  DealLender,
  DealLenderClient,
  DevelopmentFinanceDealClient,
  DevFinanceSearchClient,
  DevelopmentFinanceDeal,
  EventLogEnum,
  LenderClient,
  LenderResultClient,
  LenderResultSummaryDTO,
  OrganisationClient,
  OrganisationLinkClient,
  OwnOrPurchaseEnum,
  PreviousDevelopmentsEnum,
  ProductClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  SaveDevFinanceSearchRequest,
  ShareDealDTO,
  SortByEnum,
  StaticDataClient,
  UpdateDevFinanceSearchGetResultResponse,
  UserClient,
  DevFinanceSearchResultsResponse,
  ApplicationUserCrudClient,
  ShortlistRequest,
  IncorrectDataTypeEnum,
  SortOrderEnum,
  DealCrudClient,
  DevelopmentFinanceDealCrudClient,
  FlagIncorrectRateOrCriteriaRequest,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { MaxFlatUnitPriceEnum } from "@js/models/enum/MaxFlatUnitPriceEnum";
import { MaxHouseSalePriceEnum } from "@js/models/enum/MaxHouseSalePriceEnum";
import { MaxSqFtSalePriceEnum } from "@js/models/enum/MaxSqFtSalePriceEnum";
import { PersonalGuaranteeLevelEnum } from "@js/models/enum/PersonalGuaranteeLevelEnum";
import { ShareholderDepositRequiredEnum } from "@js/models/enum/ShareholderDepositRequiredEnum";
import { BaseLenderResultsScreenController } from "@js/controllers/BaseLenderResultsScreenController";
import { IndexService } from "@js/services/IndexService";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { ODataHelper } from "@js/helpers/ODataHelper";
import { TrustAsHtmlHelper } from "@js/helpers/TrustAsHtmlHelper";

declare const window: Window & { dataLayer: any[] };

export class DevFinanceLenderResultScreenController extends BaseLenderResultsScreenController<DevelopmentFinanceDeal> {
  // tourState: any = {
  //   tourStep: 1,
  //   tourTotalSteps: 0,
  // };
  guidanceCheckbox: boolean = true;
  // tourEnabled: boolean = false;
  totalLender: number = 0;
  isSearch: boolean = true;
  debug1: boolean = false;
  dealLenders: DealLender[];
  tempLoanCriteria = null;
  comparisonList: LenderResultSummaryDTO[] = [];
  snapshotNewSearch: boolean = false;
  showLenderNamesAndLogosOverride: boolean = false;
  dealUniqueRef: string = null;
  dealClientUniqueRef: string = null;
  orgName: string = "Brickflow";
  mortgageTerm: number = 0;

  //session storage values for enterprise journey
  userRole: string = null;
  clientId: number = null;

  //Enterprise user
  user: ApplicationUser;
  showEnterpriseRegistrationModal: boolean = false;
  projectName: string = "";
  summarySearchResults: LenderResultSummaryDTO[];
  initialSummarySearchResults: LenderResultSummaryDTO[];
  productLastVerifiedDates = {};
  sliderShown: boolean;
  isAssigned: boolean = false;
  inActiveDealLender: number = 0;
  moveContactBrokerBtnInMiddle: boolean = false;
  brokerDetail: string = "";
  brokerageOrgFilename: string;

  isLoggingOut: boolean = false;
  appName: string;

  toggleEditSearchName: boolean = false;
  showProductNote: boolean = false;
  productNote: string;
  offer: LenderResultSummaryDTO;
  loanLabel: string;
  ShowdeleteSearch: boolean = false;
  warningOff: boolean = false;
  emailExistsError: boolean = false;
  showMessageToborrower: boolean = false;
  borrowerMessage: string = "";
  showContactBrokerModal: boolean = false;

  borrowingEntityTypeOptions = [];
  interestRateTypeOptions = [];
  loanRepaymentTypeOptions = [];
  timeLeftOnLeaseOptions = [];
  numberOfPreviousDevelopmentsOptions = [];
  personalGuaranteeLevelOptions = [];
  maxIndividualUnitPriceOptions = [];
  currentUseofBuildingOptions = [];
  locationOptions = [];
  depositRequiredFromShareholdersOptions = [];
  maxHouseSalePriceOptions = [];
  maxFlatUnitPriceOptions = [];
  maxSqFtSalePriceOptions = [];
  maxPercCommercialForMixedUseOptions = [];
  maxCommercialFloorspaceOptions = [];

  shareholderDepositRequired = null;
  maxHouseSalesPrice = null;
  maxFlatUnitPrice = null;
  maxSqFtSalePrice = null;
  maxSqFtSalePriceFlats = null;
  maxPercCommercialForMixedUse = null;
  previousDevelopments = null;
  personalGuaranteeLevel = null;

  hasSearchChanged: boolean = false;
  showFilters: boolean = false;

  isProceedClicked: boolean = false;
  isSaveorSaveAsClicked: boolean = false;
  productResultList: number;
  isSaveAsWthOutIntroducee: boolean = false;
  // Flag to disable or enable the Save as button depending on the click.
  isClicked: boolean = false;
  //This boolean is used in the shareedmodal.html for all the deals
  isDevelopmentFinance: boolean = true;

  isResultScreen: boolean = true;

  //This boolean is used in the shareedmodal.html for all the deals
  isDeal: boolean = true;

  buildCostIntermediary: number;
  contingencyValue: number;

  //Postcode
  postcodeErrorMsg: string;
  isPostcodeChange: boolean = false;

  showSortBy: boolean = false;
  hasAccessToDeal: boolean = true;
  noAccessToDealMsg: string;

  //LenderReferralSearch
  isLenderReferredSearch: boolean = false;

  hasResultsProcessed: boolean = false;

  //SaveAs functionality
  reloadSearch: boolean = false;

  //Enterprise journey
  password: string = null;
  error: string = "";

  // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
  HiddenDealLenderList: DealLender[] = [];
  showExportOptions: boolean = false;

  //Confirm phone number for new client, when they register through enterprise journey from results page
  showClientPhoneNumberConfirmationModal: boolean = false;
  clientUpdatedContact: string;
  confirmClientPhoneNumberForm: ng.IFormController;
  clientUpdatedContactErrorMessage: string;

  // Logging in/resetting password
  isLoginError: boolean = false;
  isResetPasswordSubmitted: boolean = false;
  registrationLoginError: string = null;

  //inaccurate rate/criteria
  flaggedOffer: LenderResultSummaryDTO;

  filterProperties = [
    "f_IsFirstTimeDeveloper",
    "f_NumberOfPreviousDevelopments",
    "f_ShareholderDepositRequired",
    "f_IsPersonalName",
    "f_IsOffshoreCompany",
    "f_IsMainShareholderOverseas",
    "f_PersonalGuaranteeLevel",
    "f_HasAdverseCredit",
    "f_MaxCommercialFloorspace",
    "f_IsModular",
    "f_IsAirRights",
    "f_IsPermittedDevelopmentScheme",
    "f_IsGradeOneListed",
    "f_IsGradeTwoListed",
    "f_MaxHouseSalesPrice",
    "f_MaxFlatUnitPrice",
    "f_MaxSqFtSalePrice",
    "f_MaxSqFtSalePriceFlats",
    "f_MaxPercCommercialForMixedUse",
    "f_IsWorkStarted",
    "f_MaxNumberOfUnits",
    "f_IsChargeOnAdditionalProperty",
    "f_IsFixedRate",
  ];

  static $inject = [
    "$route",
    "$routeParams",
    "$scope",
    "$rootScope",
    "$location",
    "$cookies",
    "OrganisationService",
    "OrganisationClient",
    "DevFinanceSearchClient",
    "SelectListService",
    "BrickflowEventLogClient",
    "LenderClient",
    "DealLenderClient",
    "RoleService",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "SharedSearchResultsService",
    "DevFinanceDealService",
    "DevelopmentFinanceDealClient",
    "DealClient",
    "AuthService",
    "LenderResultClient",
    "DealClientClient",
    "ProductClient",
    "OrganisationLinkClient",
    "SharedDataService",
    "StaticDataClient",
    "DealLenderService",
    "CompareResultsService",
    "ODataHelper",
    "TrustAsHtmlHelper",
    "$filter",
    "$timeout",
    "DevelopmentFinanceDealCrudClient",
  ];

  constructor(
    private $route: ng.route.IRouteService,
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    $rootScope: ng.IRootScopeService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private organisationService: OrganisationService,
    organisationClient: OrganisationClient,
    private devFinanceSearchClient: DevFinanceSearchClient,
    private selectListService: SelectListService,
    eventLogClient: BrickflowEventLogClient,
    lenderClient: LenderClient,
    private dealLenderClient: DealLenderClient,
    roleService: RoleService,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private sharedSearchResultsService: SharedSearchResultsService,
    private devFinanceDealService: DevFinanceDealService,
    private developmentFinanceDealClient: DevelopmentFinanceDealClient,
    dealClient: DealClient,
    private $auth: AuthService,
    private lenderResultClient: LenderResultClient,
    private dealClientClient: DealClientClient,
    private productClient: ProductClient,
    organisationLinkClient: OrganisationLinkClient,
    sharedDataService: SharedDataService,
    private staticDataClient: StaticDataClient,
    private dealLenderService: DealLenderService,
    private compareResultsService: CompareResultsService,
    odataHelper: ODataHelper,
    trustAsHtmlHelper: TrustAsHtmlHelper,
    private $filter: ng.IFilterService,
    private $timeout: ng.ITimeoutService,
    private developmentFinanceDealCrudClient: DevelopmentFinanceDealCrudClient,
  ) {
    super(
      $rootScope,
      $location,
      applicationUserCrudClient,
      indexService,
      roleService,
      lenderClient,
      userClient,
      sharedDataService,
      organisationClient,
      eventLogClient,
      organisationLinkClient,
      dealClient,
      odataHelper,
      trustAsHtmlHelper,
    );

    if (this.$routeParams.dealId && $location.search().source === "email") {
      dealClient.getDealStatus(this.$routeParams.dealId).then((status) => {
        if (status !== undefined && status !== null && status != CaseStatusEnum.Search) {
          $location.path(`/devfinancecasedashboard/${this.$routeParams.dealId}`);
          $location.search("source", null); // Remove the query param
        } else {
          $location.search("source", null); // Still remove it if you don't need it anymore
        }
      });
    } else {
      this.init();
    }
  }

  init() {
    if (this.$location.path().startsWith("/devfinanceshortlistmore")) {
      this.isShortlistingMore = true;
    }
    //Hide header banner for borrower on page header
    /* if (
       window.self == window.top &&
       sessionStorage.getItem("userRole") &&
       sessionStorage.getItem("userRole") == "borrower" &&
       !$cookies.get("access_token")
     ) {
       document.getElementById("header").style.display = "none";
     }*/

    if (this.$routeParams.dealId) {
      if (/^\d+$/.test(this.$routeParams.dealId)) {
        // Treat the reference as an ID (e.g., fetch data using the ID)
        this.searchid = Number(this.$routeParams.dealId);
      } else {
        // Treat the reference as a unique string (e.g., fetch data using the string)
        this.dealUniqueRef = this.$routeParams.dealId;
      }
    }

    if (this.$routeParams.dealclientuniqueref) {
      this.dealClientUniqueRef = this.$routeParams.dealclientuniqueref;
    }

    if (window.self == window.top && this.$cookies.get("access_token")) {
      //This block is to navigate a broker to userdashboard when they do not have a license.
      if (sessionStorage.getItem("isValidLicense") == "false") {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      }

      this.isLoggedInUser = true;
      this.loadingData = true;
      this.organisationService
        .getOrganisation()
        .then((organisation) => {
          if (organisation) {
            this.orgCode = organisation.isWhiteLabelled ? organisation.organisationCode : "";
            this.showLenderNamesAndLogosOverride = organisation.showLenderNames ?? false;
            if (organisation.isWhiteLabelled) {
              this.orgName = organisation.name.replace(/ /g, "_");
            } else {
              this.orgName = "Brickflow";
            }
          }
        })
        .catch((error) => {
          this.loadingData = false;
        })
        .finally(() => {
          //this.loadingData = false;
        });
    } else {
      if (window.self == window.top) {
        this.userRole = sessionStorage.getItem("userRole");
        this.isClient = this.userRole == "borrower";
        this.orgCode = this.$cookies.get("org_code");
        this.clientId = Number(sessionStorage.getItem("clientId"));
        this.getSearchCriteriaAndResults();
      } else {
        this.orgCode = location.pathname.replace("/", "");
        this.guidanceCheckbox = false;
        Promise.all([
          this.organisationService.getData("userDetails").then((userDetails) => {
            if (userDetails) {
              this.user = JSON.parse(userDetails);
            }
          }),
          this.organisationService.getData("userRole").then((userRole) => {
            if (userRole) {
              this.userRole = userRole;
              this.isClient = this.userRole == "borrower";
            }
          }),
          this.organisationService.getData("clientId").then((clientId) => {
            if (clientId) {
              this.clientId = Number(clientId);
            }
          }),
          //Try get session storage if running in iframe before getting results
          this.organisationService.getData("newSearch").then((newSearch) => {
            if (newSearch) {
              this.snapshotNewSearch = Boolean(newSearch) == true;
            }
          }),
        ])
          .then(() => {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("newSearch", "false");
            this.getSearchCriteriaAndResults();
          })
          .catch((error) => {
            // One or both of the promises were rejected, handle the error
            console.error("Failed to get user data: ", error);
          });
      }
    }

    if (window.self == window.top) {
      // let cookieTourStep = this.$cookies.get("tourStep");
      // if (cookieTourStep) {
      //   this.tourState.tourStep = cookieTourStep;
      // }

      //if user is logged in, get profile
      if (this.$cookies.get("access_token")) {
        this.initialiseProfileData();
      } else {
        this.isClient = true; // if the user isn't logged in then this is the enterprise journey and should be treated as a borrower/client
      }

      // this.updateGuidanceState();

      // $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      //   this.updateGuidanceState();
      // });

      let logoutUnregister = this.$rootScope.$on("logout", (event: ng.IAngularEvent) => {
        this.isLoggingOut = true;
      });

      this.$scope.$on("$destroy", logoutUnregister);

      // $rootScope.$on("nextTour", (event: ng.IAngularEvent) => {
      //   this.tourNext();
      // });
      // $rootScope.$on("backTour", (event: ng.IAngularEvent) => {
      //   this.tourBack();
      // });
      // $rootScope.$on("skipTour", (event: ng.IAngularEvent) => {
      //   this.tourSkip();
      // });
    }

    this.numberOfPreviousDevelopmentsOptions = this.selectListService.GetNumberOfPreviousDevelopments();
    this.depositRequiredFromShareholdersOptions = this.selectListService.GetShareholderDepositRequired();
    this.personalGuaranteeLevelOptions = this.selectListService.GetPersonalGuaranteeLevels();
    this.maxHouseSalePriceOptions = this.selectListService.GetMaxHouseSalePrices();
    this.maxFlatUnitPriceOptions = this.selectListService.GetMaxFlatUnitPrices();
    this.maxSqFtSalePriceOptions = this.selectListService.GetMaxSqFtSalePrices();
    this.locationOptions = this.selectListService.GetLocations();
    this.maxCommercialFloorspaceOptions = this.selectListService.GetMaxCommercialFloorspaceOptions();
  }

  /**
   * Gets the search results and criteria for selected search
   * @param none
   */
  getSearchCriteriaAndResults() {
    if (window.self == window.top) {
      this.snapshotNewSearch = sessionStorage.getItem("newSearch") == "true";
      sessionStorage.setItem("newSearch", "false");
    }
    if (this.searchid) {
      this.loadingData = true;
      this.devFinanceSearchClient
        .getSearchCriteriaAndResults({
          dealId: this.searchid,
          criteriaChanged: this.snapshotNewSearch,
          limit: 0,
          debug1: false,
          debug2: false,
          dealClientUniqueRef: null,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
          maxShortlistsAllowed: this.noOfShortlistAllowed,
        })
        .then((results) => {
          if (!results || !results.criteria) {
            this.noAccessToDealMsg = "Unable to find deal.";
            this.hasAccessToDeal = false;
          }
          this.shortlistDisabled = !results.canShortListMore;
          if (this.shortlistDisabled) this.sliderShown = false;

          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.isLoggedInUser) this.getSelectedProducts();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.loadingData = false;
          }
          this.hasResultsProcessed = true;
        });
    } else if (this.dealUniqueRef) {
      this.loadingData = true;
      this.devFinanceSearchClient
        .getSearchCriteriaAndResults({
          dealUniqueRef: this.dealUniqueRef,
          criteriaChanged: this.snapshotNewSearch,

          limit: 0,
          debug1: false,
          debug2: false,
          dealId: null,
          dealClientUniqueRef: null,
          returnSearchCriteriaDTO: true,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.loanCriteria) this.getSelectedProducts();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.loadingData = false;
          }
          this.hasResultsProcessed = true;
        });
    } else if (this.dealClientUniqueRef) {
      this.loadingData = true;
      this.devFinanceSearchClient
        .getSearchCriteriaAndResults({
          dealClientUniqueRef: this.dealClientUniqueRef,
          criteriaChanged: this.snapshotNewSearch,

          dealId: null,
          limit: 0,
          debug1: false,
          debug2: false,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.loanCriteria) this.getSelectedProducts();

          if (this.compareResultsService.exists() && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));

            //Removing lsd data saved for compare view.
            this.compareResultsService.clear();
            sessionStorage.removeItem("ComparisonList");
          }
        })
        .catch((error) => {})
        .finally(() => {
          if (this.loanCriteria) {
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.loadingData = false;
          }
          this.hasResultsProcessed = true;
        });
    }
  }

  checkDeletedLender(lenderId: number, productId: number): boolean {
    if (this.isShortlistingMore && this.deletedDealLenders) {
      const deletedLender = this.deletedDealLenders.find((deletedLender) => deletedLender.lenderId === lenderId);

      if (deletedLender) {
        return deletedLender.productId === productId;
      }
    }
    return false;
  }

  postResultsProcessing(results: DevFinanceSearchResultsResponse) {
    if (results.hasNoAccessToDeal) {
      this.hasAccessToDeal = false;
      if (this.isClient) {
        this.noAccessToDealMsg = "Please contact your broker in order to access this case.";
      } else {
        this.noAccessToDealMsg = "Error retrieving deal.";
      }
    } else {
      this.summarySearchResults = this.initialSummarySearchResults = results.results;
      this.loanCriteria = results.criteria;

      if (this.isLoggedInUser) {
        this.validateAccessAndRedirect();
      }

      this.sortSummaryResults();

      if (this.loanCriteria.loanTermReq && this.loanCriteria.loanTermReq > 0) {
        this.mortgageTerm = this.loanCriteria.loanTermReq / 12;
      }

      if (this.isLoggedInUser) {
        if (this.dealClientUniqueRef) {
          if (this.isClient) {
            this.eventLogClient.logPageLoad(
              "AFTER-ENTERPRISE-LEAD-REGISTRATION-USING-EMAIL-LINK",
              this.orgCode,
              this.selectedUserName,
              "Client",
              this.loanCriteria?.organisationLinkId,
              this.loanCriteria.productType,
              "",
              this.loanCriteria?.id,
            );
          }
        } else {
          if (this.loanCriteria.lenderReferralLenderId) this.isLenderReferredSearch = true;

          // Showing confirm client phone number modal once client register through result page
          if (this.isClient && sessionStorage.getItem("showConfirmClientPhoneNo") == "true") {
            this.showClientPhoneNumberConfirmationModal = true;
            this.clientUpdatedContact = this.loanCriteria?.dealClients[0].client.phoneNumber;
          }

          // Expanding a 'new search' panel for first time search execution
          if (window.self == window.top && sessionStorage.getItem("newSearch")) {
            this.sliderShown =
              (this.$rootScope as any).previousRoute.startsWith("/compare") ||
              this.showClientPhoneNumberConfirmationModal
                ? false
                : true;
            sessionStorage.removeItem("newSearch");
          }
        }
      } else {
        if (this.$location.path().startsWith("/e/devfinanceresults")) {
          this.populateEnterpriseClientValue("LENDERRESULTS");
        }

        if (this.dealClientUniqueRef) {
          if (this.$routeParams.showOnlyRegister == "false") this.isClient = true;
          this.populateEnterpriseClientValue("LENDERRESULTS-USING-EMAIL-LINK");
        }
      }
      var owner =
        this.loanCriteria.dealClients != null && this.loanCriteria.dealClients?.length > 0
          ? this.loanCriteria.dealClients.find((dc) => dc.isPrimary)
          : null;

      if (owner) {
        this.isAssigned = true;
      }
    }
  }

  getSearchLenderCount() {
    this.lenderClient
      .getTotalLenders(ProductFamilyEnum.Development, this.loanCriteria.brokerOrganisationId)
      .then((result: number) => {
        this.totalLender = result;
      });
  }

  getSelectedProducts() {
    if (this.summarySearchResults && this.summarySearchResults.length > 0) {
      this.dealLenderClient
        .fetchDealLendersByDealId(this.dealClientUniqueRef || this.dealUniqueRef ? this.loanCriteria.id : this.searchid)
        .then((results) => {
          this.dealLenders = results;
        })
        .then(() => {
          this.comparisonList = this.summarySearchResults.filter((result) => {
            const isDealLender = this.dealLenders.find((dealLender) => dealLender.productId === result.productID);
            if (isDealLender) {
              result.dealLenderStatus = isDealLender.status;
            }
            return (result.isDealLender = Boolean(isDealLender));
          });

          // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
          this.HiddenDealLenderList = this.dealLenders.filter(
            (l) => !this.summarySearchResults.some((s) => l.productId === s.productID),
          );

          if (this.comparisonList.length > 0) {
            var inActiveDealLenderList = this.comparisonList.filter(
              (ia) =>
                ia.dealLenderStatus == CaseLenderStateEnum.Rejected ||
                ia.dealLenderStatus == CaseLenderStateEnum.Withdrawn,
            );
            this.inActiveDealLender = inActiveDealLenderList.length;
          }

          if (this.compareResultsService.exists() && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            if (sessionStorage.getItem("actualcomparisonList")) {
              var selectedProducts = sessionStorage.getItem("actualcomparisonList");
              this.comparisonList = JSON.parse(selectedProducts);
              sessionStorage.removeItem("actualcomparisonList");
            } else {
              this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));
            }
            if (this.inActiveDealLender > 0) {
              this.comparisonList = this.comparisonList.concat(inActiveDealLenderList);
            }

            //Removing lsd data saved for compare view.
            this.compareResultsService.clear();
            sessionStorage.removeItem("ComparisonList");
          }
        });
    }
  }

  getOrganisationAndBrokerDetails() {
    if (!this.isLoggedInUser && !this.isAdmin && !this.isBroker) {
      this.loadingData = true;
      this.organisationClient
        .getOrganisationAndBrokerByDealId(this.loanCriteria.id)
        .then((response) => {
          if (response && response.organisation != null) {
            this.brokerageOrg = response.organisation;

            if (response.organisation.isBrickflow) {
              this.moveContactBrokerBtnInMiddle = true;
            } else {
              if (response.broker != null) {
                this.brokerDetail = `${response.broker.fullName} (${response.broker.email})`;
              }

              if (this.brokerageOrg.isWhiteLabelled) {
                this.orgName = this.brokerageOrg.name.replace(/ /g, "_");
              }
            }
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    }
  }

  /**
   * Saves the new search name on the edit.
   * @param none
   */
  doRenameSearch() {
    if (this.loanCriteria.name != null && this.loanCriteria.name.length <= 0) {
      this.loanCriteria.name = this.tempLoanCriteria.name;
    }

    if (!this.isLoggedInUser) {
      this.openRegisterModal();
      return;
    }

    const request: SaveDevFinanceSearchRequest = {
      deal: this.loanCriteria,
      shareDealDto: this.shareDealDto,
      orgCode: this.orgCode,
      enterpriseClientDto: null,
    } as SaveDevFinanceSearchRequest;

    if (this.searchid) {
      this.developmentFinanceDealClient.saveDevFinanceSearchReturnsId(request).then((response) => {
        this.toggleEditSearchName = false;
      });
    } else if (this.dealUniqueRef) {
      this.developmentFinanceDealClient.saveDevFinanceSearchReturnsUniqueRef(request).then((response) => {
        this.toggleEditSearchName = false;
      });
    } else {
      this.toggleEditSearchName = false;
    }
  }

  toggleLenderComparisonSelection(item: LenderResultSummaryDTO, index: number) {
    let comparisonMatches: LenderResultSummaryDTO[] = this.comparisonList.filter((result, index) => {
      return result.productID === item.productID;
    });

    if (!comparisonMatches || comparisonMatches.length === 0) {
      this.comparisonList.push(item);
      this.eventLogClient.logEvent(
        `SHORTLISTING-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productID.toString(),
        0,
      );
    } else {
      if (
        this.isShortlistingMore &&
        item.isDealLender &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        this.loanCriteria.status != CaseStatusEnum.NewCase
      )
        return;
      comparisonMatches.forEach((value, index) => {
        this.comparisonList.splice(this.comparisonList.indexOf(value), 1);
      });
      this.eventLogClient.logEvent(
        `DESELECTING-SHORTLISTED-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productID.toString(),
        0,
      );
    }
    //This is user for shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  //This is used in shortlisting pdf
  prepareDataForShortlistPdf() {
    this.loanCriteria.comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );
  }

  comparisonContains(item: LenderResultSummaryDTO): boolean {
    return !!this.comparisonList.find((result, index) => {
      return result.productID === item.productID;
    });
  }

  selectionOrderNumber(item: LenderResultSummaryDTO) {
    var activeProductList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    var hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;

    var order = activeProductList.map((item) => item.productID).indexOf(item.productID) + hiddenProductLength + 1;
    if (order === 0) {
      return " ";
    }

    return order;
  }

  /**
   * Processes the clicking of the "View Eligibility" anchor/button and index to show on the row number
   * @param item BridgingLenderResultSummaryDTO
   */
  viewEligibility(item: LenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.showProductNote = true;
    this.offer = item;
    this.loanLabel = item.loanLabel;
    this.productNote = item.additionalProductInfo;
  }

  /**
   *Marks a selected search as a deleted
   * @param
   */
  deleteSearch() {
    if (this.$routeParams.dealId) {
      this.dealClient
        .markAsDeleted(this.$routeParams.dealId)
        .then((response) => {
          this.displayMsg = "Search is successfully deleted";
          this.showMsg = true;
          this.ShowdeleteSearch = true;
        })
        .catch((error) => {
          this.displayMsg = "Sorry, something went wrong. Please try again.";
          this.showMsg = true;
        });
    }
  }

  closeDeleteModal() {
    this.showMsg = false;
    this.displayMsg = null;
    this.ShowdeleteSearch = false;
    this.warningOff = true;
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  viewSingleLoan(item: LenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.warningOff = true;
    //Storing the actual comparisonList to local storage so that to recover it later when we comeback to result screen from compare screen.
    sessionStorage.setItem("actualcomparisonList", JSON.stringify(this.comparisonList));
    this.comparisonList = [];

    this.comparisonList.push(item);
    this.goCompare();
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
  }

  goCompare() {
    this.warningOff = true;

    this.sharedSearchResultsService.clearStorageDataForCompareView();

    let comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    sessionStorage.setItem("ComparisonList", JSON.stringify(comparisonList));
    this.compareResultsService.saveDealToSessionStorage(this.loanCriteria);

    if (this.dealClientUniqueRef) {
      if (!this.isLoggedInUser) {
        this.dealUniqueRef = this.loanCriteria.uniqueRef;
        //This property is used in compare view controller to find previous route
        sessionStorage.setItem("DealClientUniqueRef", this.dealClientUniqueRef);
      } else {
        this.searchid = this.loanCriteria.id;
      }
    }

    if (this.searchid) {
      this.$location.path("compare/" + this.searchid + "/" + 0 + "/" + true);
    } else {
      this.$location.path("compare/" + this.dealUniqueRef + "/" + 0 + "/" + true);
    }
  }

  showBookMeetingButton() {
    return !this.isLoggedInUser && this.isClient && this.brokerDetail == "" && this.brokerageOrg != null;
  }

  bookMeeting() {
    this.staticDataClient.getHubspotDeveloperBookMeetingWithSearch().then((hubSpotUrl: string) => {
      window.open(hubSpotUrl);
    });
  }

  sendMessageToBroker(message) {
    this.loadingData = true;
    this.borrowerMessage = null;
    this.organisationClient
      .sendBorrowerMessageToSearchBroker(
        this.loanCriteria.id,
        message,
        this.loanCriteria.dealClients[0].client.firstName,
        this.loanCriteria.dealClients[0].client.lastName,
        this.loanCriteria.dealClients[0].client.email,
        ProductTypeEnum.Development,
        "Results",
        "",
      )
      .then((results) => {
        if (results) {
          this.displayMsg = `Message has been sent successfully.`;
          this.showMessageToborrower = true;
        } else {
          this.displayMsg = `There is problem sending a message, Please try later.`;
          this.showMessageToborrower = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  closeContactBrokerModal() {
    this.showContactBrokerModal = false;
    this.showMessageToborrower = false;
    this.displayMsg = null;
  }

  getTotalShortlistedLenders() {
    var activeDealLenders = this.comparisonList.filter(
      (al) =>
        al.dealLenderStatus != CaseLenderStateEnum.Rejected && al.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    var hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;

    return activeDealLenders.length + hiddenProductLength;
  }

  go(path): void {
    this.$location.path(path);
  }

  changeSearch() {
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
    this.warningOff = true;
    sessionStorage.setItem("skip", "true");
    if (!this.isLoggedInUser && (this.dealUniqueRef || this.dealClientUniqueRef)) {
      if (this.dealClientUniqueRef) sessionStorage.setItem("previousRoute", "referredsearchdeal");
      var url = `/e/devfinancecriteria/${this.loanCriteria.uniqueRef}`;
      if (this.loanCriteria.organisationLinkId > 0) {
        url = `${url}/${this.loanCriteria.organisationLinkId}`;
      }
      this.go(url);
    } else if (this.searchid) {
      this.go("/devfinancecriteria/" + this.searchid);
    } else {
      this.go("/devfinancecriteria");
    }
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/devfinancecriteria/0");
  }

  updateSearchViaSlider(isAdminDebugValueChanged: boolean = false): void {
    if (
      this.searchPanelForm.$valid &&
      !this.showPostcodeErrorMessage &&
      this.loanCriteria.loanTermReq > this.loanCriteria.buildTerm
    ) {
      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
        if (this.loanCriteria.purchasePrice <= 0) return;
      }

      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        if (this.loanCriteria.currentvalue <= 0) return;
      }

      if (this.loanCriteria.gdv <= 0) return;

      this.loadingData = true;
      this.hasSearchChanged = true;

      this.clearSelected();

      this.updateCriteriaAndGetResults(isAdminDebugValueChanged && this.isAdmin ? false : true);
    }
  }

  clearSelected() {
    if (this.isShortlistingMore) {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => result.productID == item.productID),
      );

      const dealLenders = this.initialSummarySearchResults.filter((result) => result.isDealLender);

      dealLenders.forEach((dealLender) => {
        if (!this.comparisonList.some((item) => item.productID === dealLender.productID)) {
          this.comparisonList.push(dealLender);
        }
      });
    } else {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => result.productID == item.productID),
      );
    }
  }

  updateCriteriaAndGetResults(criteriaChanged: boolean, updateLoanLabels: boolean = false) {
    if (this.loanCriteria.loanTermReq >= this.loanCriteria.buildTerm) {
      this.developmentFinanceDealClient
        .updateSearchAndGetResults({
          devFinanceDeal: this.loanCriteria,
          criteriaChanged: criteriaChanged,
          limit: 0,
          debug1: this.debug1,
          debug2: false,
          isPostcodeChange: this.isPostcodeChange,
          isShortlistingMore: this.isShortlistingMore,
        })
        .then((results: UpdateDevFinanceSearchGetResultResponse) => {
          if (this.isPostcodeChange) {
            if (results.criteriaLocation != null) {
              this.loanCriteria.locations = results.criteriaLocation;
              this.summarySearchResults = results.results;
              this.sortSummaryResults();
            } else {
              this.postcodeErrorMsg = results.postCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
            }
          } else {
            this.summarySearchResults = results.results;
            this.sortSummaryResults();
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.tempLoanCriteria = { ...this.loanCriteria };
          this.clearSelected();
          this.isPostcodeChange = false;

          if (updateLoanLabels) {
            this.updateLoanLabels();
          }
          this.loadingData = false;
        });
    }
  }

  getSearchResultCount() {
    return this.sharedSearchResultsService.getSearchResultCount(this.summarySearchResults);
  }

  onPersonalGuaranteeLevelOptionsChange(e: PersonalGuaranteeLevelEnum) {
    switch (e) {
      case PersonalGuaranteeLevelEnum.UpTo20Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.2;
        break;
      case PersonalGuaranteeLevelEnum.TwentyOneTo35Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.35;
        break;
      case PersonalGuaranteeLevelEnum.ThirtySixTo50Percent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 0.5;
        break;
      case PersonalGuaranteeLevelEnum.OneHundredPercent:
        this.loanCriteria.f_PersonalGuaranteeLevel = 1.0;
        break;
      default:
        this.loanCriteria.f_PersonalGuaranteeLevel = null;
        break;
    }
  }

  getPersonalGuaranteeLevelOptions() {
    var value = null;
    switch (this.tempLoanCriteria.f_PersonalGuaranteeLevel) {
      case 0.2:
        value = PersonalGuaranteeLevelEnum.UpTo20Percent;
        break;
      case 0.35:
        value = PersonalGuaranteeLevelEnum.TwentyOneTo35Percent;
        break;
      case 0.5:
        value = PersonalGuaranteeLevelEnum.ThirtySixTo50Percent;
        break;
      case 1.0:
        value = PersonalGuaranteeLevelEnum.OneHundredPercent;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  applyFilters() {
    this.loadingData = true;
    this.showFilters = false;
    this.updateCriteriaAndGetResults(false);
  }

  doClearClientFilters() {
    this.loanCriteria.f_IsFirstTimeDeveloper = null;
    this.loanCriteria.f_NumberOfPreviousDevelopments = null;
    this.loanCriteria.f_ShareholderDepositRequired = null;
    this.shareholderDepositRequired = null;
    this.loanCriteria.f_IsPersonalName = null;
    this.loanCriteria.f_IsOffshoreCompany = null;
    this.loanCriteria.f_IsMainShareholderOverseas = null;
    this.loanCriteria.f_PersonalGuaranteeLevel = null;
    this.personalGuaranteeLevel = null;
    this.loanCriteria.f_HasAdverseCredit = null;
    this.loanCriteria.f_MaxCommercialFloorspace = null;
  }

  showClearForClientFilters() {
    if (
      this.loanCriteria.f_IsFirstTimeDeveloper != null ||
      this.loanCriteria.f_NumberOfPreviousDevelopments != null ||
      this.loanCriteria.f_ShareholderDepositRequired != null ||
      this.loanCriteria.f_IsPersonalName != null ||
      this.loanCriteria.f_IsOffshoreCompany != null ||
      this.loanCriteria.f_IsMainShareholderOverseas != null ||
      this.loanCriteria.f_PersonalGuaranteeLevel != null ||
      this.loanCriteria.f_HasAdverseCredit != null ||
      this.loanCriteria.f_MaxCommercialFloorspace != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  toggleCheckbox(variableName) {
    if (this.loanCriteria[variableName] === null || this.loanCriteria[variableName] === false) {
      this.loanCriteria[variableName] = true;
    } else {
      this.loanCriteria[variableName] = null;
    }
  }

  doClearPropertyFilters() {
    this.loanCriteria.f_IsAirRights = null;
    this.loanCriteria.f_IsModular = null;
    this.loanCriteria.f_IsPermittedDevelopmentScheme = null;
    this.loanCriteria.f_IsGradeOneListed = null;
    this.loanCriteria.f_IsGradeTwoListed = null;
    this.loanCriteria.f_MaxHouseSalesPrice = null;
    this.loanCriteria.f_MaxFlatUnitPrice = null;
    this.loanCriteria.f_MaxNumberOfUnits = null;
    this.loanCriteria.f_MaxPercCommercialForMixedUse = null;
    this.loanCriteria.f_MaxSqFtSalePrice = null;
    this.loanCriteria.f_MaxSqFtSalePriceFlats = null;
    this.loanCriteria.f_IsWorkStarted = null;
    this.maxHouseSalesPrice = null;
    this.maxFlatUnitPrice = null;
    this.maxSqFtSalePrice = null;
    this.maxPercCommercialForMixedUse = null;
    this.maxSqFtSalePriceFlats = null;
    this.previousDevelopments = null;
  }

  showClearForPropertyFilters() {
    if (
      this.loanCriteria.f_IsAirRights != null ||
      this.loanCriteria.f_IsModular != null ||
      this.loanCriteria.f_IsPermittedDevelopmentScheme != null ||
      this.loanCriteria.f_IsGradeOneListed != null ||
      this.loanCriteria.f_IsGradeTwoListed != null ||
      this.loanCriteria.f_MaxHouseSalesPrice != null ||
      this.loanCriteria.f_MaxFlatUnitPrice != null ||
      this.loanCriteria.f_MaxNumberOfUnits != null ||
      this.loanCriteria.f_MaxPercCommercialForMixedUse != null ||
      this.loanCriteria.f_MaxSqFtSalePrice != null ||
      this.loanCriteria.f_IsWorkStarted != null ||
      this.loanCriteria.f_MaxSqFtSalePriceFlats != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  doClearFinanceFilters() {
    this.loanCriteria.f_IsChargeOnAdditionalProperty = null;
    this.loanCriteria.f_IsFixedRate = null;
  }

  showClearForFinanceFilters() {
    if (this.loanCriteria.f_IsChargeOnAdditionalProperty != null || this.loanCriteria.f_IsFixedRate != null) {
      return true;
    } else {
      return false;
    }
  }

  debugSearch() {
    const stringJSON = JSON.stringify(this.loanCriteria);
    navigator.clipboard
      .writeText(stringJSON)
      .then()
      .catch((e) => console.log(e));
  }

  checkFilterSelected(property: string) {
    return this.sharedSearchResultsService.checkFilterSelected(property, this.tempLoanCriteria);
  }

  getDisplayTextForProperty(property) {
    if (property == "f_MaxNumberOfUnits") {
      return `Max ${this.loanCriteria.f_MaxNumberOfUnits} Units`;
    } else {
      return this.sharedSearchResultsService.getDisplayTextForProperty(property);
    }
  }

  getPropertyValue(property) {
    let propertyValue = this.loanCriteria[property];
    switch (property) {
      case "f_ShareholderDepositRequired":
        return this.selectListService
          .GetShareholderDepositRequired()
          .find((item) => item.key === this.getShareholderDepositRequired())?.displayName;
      case "f_PersonalGuaranteeLevel":
        return this.selectListService
          .GetPersonalGuaranteeLevels()
          .find((item) => item.key === this.getPersonalGuaranteeLevelOptions())?.displayName;
      case "f_MaxHouseSalesPrice":
        return this.selectListService.GetMaxHouseSalePrices().find((item) => item.key === this.getMaxHouseSalesPrice())
          ?.displayName;
      case "f_MaxFlatUnitPrice":
        return this.selectListService.GetMaxFlatUnitPrices().find((item) => item.key === this.getMaxFlatUnitPrice())
          ?.displayName;
      case "f_MaxSqFtSalePrice":
        return this.selectListService.GetMaxSqFtSalePrices().find((item) => item.key === this.getMaxSqFtSalePrice())
          ?.displayName;
      case "f_MaxSqFtSalePriceFlats":
        return this.selectListService
          .GetMaxSqFtSalePrices()
          .find((item) => item.key === this.getMaxSqFtSalePriceFlats())?.displayName;
      case "f_NumberOfPreviousDevelopments":
        return this.selectListService
          .GetNumberOfPreviousDevelopments()
          .find((item) => item.key === this.getPreviousDevelopments())?.displayName;
      case "f_MaxNumberOfUnits":
        return propertyValue;
      case "f_MaxCommercialFloorspace":
        return this.selectListService
          .GetMaxCommercialFloorspaceOptions()
          .find((item) => item.key === this.tempLoanCriteria.f_MaxCommercialFloorspace)?.displayName;
      default:
        return propertyValue;
    }
  }

  filterPropertyToText(property: string) {
    if (property === "f_MaxNumberOfUnits") return;

    let value = this.tempLoanCriteria[property];
    if (typeof value == "boolean" && value == true) {
      return;
    } else if (value != null && typeof value != "boolean") {
      return `: ${this.getPropertyValue(property)}`;
    } else if (value == null) {
      return;
    }
    return false;
  }

  countFiltersSelected() {
    let count = 0;
    count = this.sharedSearchResultsService.countFiltersSelected(this.tempLoanCriteria, this.filterProperties);
    return count;
  }

  gotoSignInPage() {
    this.$location.path("/login");
  }

  goToLink(url) {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    var newUrl = baseUrl + url;
    window.open(newUrl, "_blank");
  }

  /**
   * Opens a 'share a search with client' modal if search do not have client attached to.
   * @param none
   */
  saveResultsForShareSearchToClient() {
    if (!this.isSaveAsClicked) {
      this.register(false, this.productResultList);
    } else {
      this.saveSaveAsSearch();
    }
    this.newSearch = false;
  }

  /**
   * Saves the search or saves the search and create a case.
   * @param createCase (boolean set to true when promoting search to case)
   */

  //TODO: this functon does not need a productResultList parameter but as views have been shared with devfinance we are passing it
  register(createCase: boolean = false, productResultList: number) {
    this.loadingData = true;
    if (this.isShortlistingMore) {
      if (this.validateWithdrawnLendersUnique() == true) {
        this.dealLenderClient
          .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, this.getDealLenders(this.comparisonList))
          .then((response) => {})
          .then(() => {
            this.getSelectedProducts();
          })
          .finally(() => {
            this.loadingData = false;
          });
      } else {
        this.loadingData = false;
      }
    } else {
      if (this.shareDealDto && this.shareDealDto.dealName && this.shareDealDto.dealName.length > 0) {
        this.loanCriteria.name = this.shareDealDto.dealName;
      }

      const request: SaveDevFinanceSearchRequest = {
        deal: this.loanCriteria,
        shareDealDto: null,
        orgCode: "",
        enterpriseClientDto: null,
      } as SaveDevFinanceSearchRequest;

      this.developmentFinanceDealClient
        .saveDevFinanceSearchReturnsId(request)
        .then((response) => {
          this.loanCriteria.id = response as number;
          this.loadingData = false;

          // Creating the case is done on the casedashboard for deals
          if (createCase) {
            this.$location.path("/devfinancecasedashboard/" + this.loanCriteria.id + "/" + true);
          }

          var shortlistDealLenders = this.getDealLenders(this.comparisonList);

          const shortlistRequest: ShortlistRequest = {
            dealLenders: shortlistDealLenders,
            commercialShortlistedResults: null,
            bridgingShortlistedResults: null,
            devFinanceShortlistedResults: this.comparisonList,
          } as ShortlistRequest;

          this.dealLenderClient
            .dealLenderAddUpdateListReturnOnlyId(shortlistRequest)
            .then((response) => {
              if (this.dealLenders != null) {
                let deallenders = this.dealLenders.filter((lender) => response.indexOf(lender.id) === -1);

                deallenders.forEach((lender) => this.dealLenderClient.markAsDeleted(lender.id));
              }
            })
            .finally(() => {
              this.getSelectedProducts();
              this.isClicked = false;
              this.newSearch = false;
              this.isProceedClicked = false;
              this.showSaveResults = null;
              this.loadingData = false;
            });
        })
        .catch((response) => {
          //TODO BRIDGING - capture if an error has occurred and process it
          //this.isError = true;
          this.isProceedClicked = false;
        })
        .finally(() => {});
    }
  }

  /**
   * updates a seach with introducee details and saves it and sends emil to client if 'notifyBorrower' is set to true.
   * @param notifyBorrower
   */

  sendResultsToClient(notifyBorrower) {
    if (this.shareDealDto != null && this.shareDealDto.clientDto != null) {
      this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      };
    }
    if (this.isSaveAsClicked) {
      this.saveSaveAsSearch(true);
    } else {
      this.loadingData = true;
      this.dealClient
        .shareDeal(this.shareDealDto)
        .then(() => {
          this.displayMsg = this.shareDealDto.emailLinkToClient
            ? "Search results have been sent to " +
              this.shareDealDto.clientDto.firstName +
              " " +
              this.shareDealDto.clientDto.lastName
            : "Search assigned to " +
              this.shareDealDto.clientDto.firstName +
              " " +
              this.shareDealDto.clientDto.lastName;
          //this.loanCriteria.dealClients[0] = this.shareDealDto.ClientDto;
          this.loanCriteria.name = this.shareDealDto.dealName;
          this.newSearch = false;
          this.showMsg = true;
          this.loadingData = false;
          this.isAssigned = true;
          this.reloadSearch = true;
        })
        .finally(() => {
          delete this.shareDealDto;
          this.loadingData = false;
        });
    }
  }

  getDealLenders(selectedLenders: LenderResultSummaryDTO[]) {
    var lendersList: DealLender[] = [];

    if (this.dealClientUniqueRef || this.dealUniqueRef) {
      this.searchid = this.loanCriteria.id;
    }

    selectedLenders.forEach(({ productID, lenderID, grossLoan }) => {
      var dealLender: DealLender;

      if (this.dealLenders) {
        dealLender = this.dealLenders.find(
          (dl) => dl.dealId === this.searchid && dl.productId === productID && dl.lenderId === lenderID,
        );
      }

      if (!dealLender) {
        dealLender = {
          dealId: this.searchid,
          deal: null,
          productId: productID,
          product: null,
          lenderId: lenderID,
          lender: null,
          status: CaseLenderStateEnum.Shortlisted,
          originalTotalGrossLoan: grossLoan,
        } as DealLender;
      }

      lendersList.push(dealLender);
    });

    var unselecteLenderList: DealLender[] = [];

    if (this.dealLenders) {
      unselecteLenderList = this.dealLenders.filter(
        (dl) =>
          !lendersList.some((ll) => ll.productId === dl.productId && ll.lenderId === dl.lenderId) &&
          (dl.status == CaseLenderStateEnum.Rejected || dl.status == CaseLenderStateEnum.Withdrawn),
      );
    }

    if (unselecteLenderList.length > 0) {
      unselecteLenderList.forEach((l) => {
        l.isDeleted = true;
        lendersList.push(l);
      });
    }

    return lendersList;
  }

  openSendResultsToBorrowerModal() {
    var client: Client = this.loanCriteria.dealClients[0]["client"]; // TODO Deal FUTURE- always want to assume there's one for now until there's a redesign of sharing
    this.shareDealDto.dealId = this.loanCriteria.id;
    this.shareDealDto.dealName = this.loanCriteria.name;
    this.shareDealDto.isApplicant = true;
    this.shareDealDto.isPrimary = true;
    this.shareDealDto.clientDto = {
      firstName: client.firstName,
      lastName: client.lastName,
      email: client.email,
      phoneNumber: client.phoneNumber,
      clientUserId: client.clientUserId,
      postalAddress: client.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as Client;
    this.existingborrower = null;
    this.newSearch = true;
    this.sharedSearch = true;
  }

  /**
   * Sends email to client attached to the search
   */
  sendShareSearchEmailToClient() {
    this.loadingData = true;
    this.shareDealDto.emailLinkToClient = true;
    this.dealClient
      .shareDeal(this.shareDealDto)
      .then(() => {
        this.displayMsg =
          "Search results have been sent to " +
          this.shareDealDto.clientDto.firstName +
          " " +
          this.shareDealDto.clientDto.lastName;
      })
      .catch((error) => {
        this.displayMsg = "Sorry, something went wrong. Please try again.";
      })
      .finally(() => {
        this.newSearch = false;
        this.showMsg = true;
        this.loadingData = false;
        this.sharedSearch = false;
      });
  }

  applyForLoan() {
    this.isProceedClicked = true;
    this.register(true, this.productResultList);
  }

  returnToCase() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: null,
      bridgingShortlistedResults: null,
      devFinanceShortlistedResults: this.comparisonList,
    } as ShortlistRequest;

    if (this.isShortlistingMore) {
      // copy newly selected products/lenders to caselender
      this.dealLenderClient
        .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, shortlistRequest)
        .then((response) => {
          if (response) {
            //sending 'Promote' as true if search has changed & 'NewShortlist' as true if isShortlistingMore
            this.$location.path(
              "/devfinancecasedashboard/" +
                this.loanCriteria.id +
                "/" +
                null +
                "/" +
                true +
                "/" +
                this.hasSearchChanged,
            );
          }
        });
    } else {
      this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {
        this.$location.path("/devfinancecasedashboard/" + this.loanCriteria.id);
      });
    }
  }

  toggleShowLenderNamesBrokerOverride() {
    if (this.searchPanelForm.$valid && !this.showPostcodeErrorMessage) {
      this.loadingData = true;
      this.updateCriteriaAndGetResults(false, true);
    }
  }

  mortgageTermToLoanTerm(): void {
    this.loanCriteria.loanTermReq = this.mortgageTerm * 12;
  }

  /**Update the loan label in the comparison results based on the loan label returned in the results
   * Primary purpose is to update the loan label when the show lender names button is toggled
   * */
  updateLoanLabels() {
    for (var i = 0; i < this.comparisonList.length; i++) {
      let resultIndex = this.summarySearchResults.findIndex(
        (item) => item.productID == this.comparisonList[i].productID,
      );

      if (resultIndex > -1) {
        this.comparisonList[i].loanLabel = this.summarySearchResults[resultIndex].loanLabel;
      }
    }

    //This is used in shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  datasetupOnMaxLoanRequiredChange() {
    this.loanCriteria = DealHelper.dataSetupOnMaxLoanRequiredChange(this.loanCriteria);
    this.updateSearchViaSlider();
  }

  showContactbrokerButton() {
    if (
      this.brokerageOrg != null &&
      this.loanCriteria != null &&
      this.loanCriteria.dealClients != null &&
      this.loanCriteria.dealClients.length > 0 &&
      this.loanCriteria.dealClients[0]?.client != null &&
      this.loanCriteria.dealClients[0].client.email.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  getPreviousDevelopments() {
    var value = null;
    switch (this.tempLoanCriteria.f_NumberOfPreviousDevelopments) {
      case 1:
        value = PreviousDevelopmentsEnum.One;
        break;
      case 2:
        value = PreviousDevelopmentsEnum.Two;
        break;
      case 3:
        value = PreviousDevelopmentsEnum.Three;
        break;
      case 4:
        value = PreviousDevelopmentsEnum.FourOrMore;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getShareholderDepositRequired() {
    var value = null;
    switch (this.tempLoanCriteria.f_ShareholderDepositRequired) {
      case 0:
        value = ShareholderDepositRequiredEnum.None;
        break;
      case 0.25:
        value = ShareholderDepositRequiredEnum.UpTo25Percent;
        break;
      case 0.5:
        value = ShareholderDepositRequiredEnum.TwentyFiveTo50Percent;
        break;
      case 1.0:
        value = ShareholderDepositRequiredEnum.FiftyPercentPlus;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onShareholderDepositRequiredChange(e: ShareholderDepositRequiredEnum) {
    switch (e) {
      case ShareholderDepositRequiredEnum.None:
        this.loanCriteria.f_ShareholderDepositRequired = 0;
        break;
      case ShareholderDepositRequiredEnum.UpTo25Percent:
        this.loanCriteria.f_ShareholderDepositRequired = 0.25;
        break;
      case ShareholderDepositRequiredEnum.TwentyFiveTo50Percent:
        this.loanCriteria.f_ShareholderDepositRequired = 0.5;
        break;
      case ShareholderDepositRequiredEnum.FiftyPercentPlus:
        this.loanCriteria.f_ShareholderDepositRequired = 1.0;
        break;
      default:
        this.loanCriteria.f_ShareholderDepositRequired = null;
        break;
    }
  }

  onMaxHouseSalesPriceChange(e: MaxHouseSalePriceEnum) {
    switch (e) {
      case MaxHouseSalePriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 1000000;
        break;
      case MaxHouseSalePriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 2000000;
        break;
      case MaxHouseSalePriceEnum.UpTo5Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 5000000;
        break;
      case MaxHouseSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxHouseSalesPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxHouseSalesPrice = null;
        break;
    }
  }

  getMaxHouseSalesPrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxHouseSalesPrice) {
      case 1000000:
        value = MaxHouseSalePriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxHouseSalePriceEnum.UpTo2Million;
        break;
      case 5000000:
        value = MaxHouseSalePriceEnum.UpTo5Million;
        break;
      case -999:
        value = MaxHouseSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxFlatUnitPriceChange(e: MaxFlatUnitPriceEnum) {
    switch (e) {
      case MaxFlatUnitPriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 1000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 2000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo3Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 3000000;
        break;
      case MaxFlatUnitPriceEnum.NoMax:
        this.loanCriteria.f_MaxFlatUnitPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxFlatUnitPrice = null;
        break;
    }
  }

  getMaxFlatUnitPrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxFlatUnitPrice) {
      case 1000000:
        value = MaxFlatUnitPriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxFlatUnitPriceEnum.UpTo2Million;
        break;
      case 3000000:
        value = MaxFlatUnitPriceEnum.UpTo3Million;
        break;
      case -999:
        value = MaxFlatUnitPriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxSqFtSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePrice = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePrice = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePrice = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePrice = null;
        break;
    }
  }

  onMaxSqFtFlatsSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = null;
        break;
    }
  }

  getMaxSqFtSalePrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxSqFtSalePrice) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getMaxSqFtSalePriceFlats() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxSqFtSalePriceFlats) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  CalcPurchaseAdditionalCosts(): number {
    if (this.loanCriteria) {
      var res: number = 0;

      if (this.loanCriteria.stampDutyLandTax) {
        res += Number(this.loanCriteria.stampDutyLandTax);
      }
      if (this.loanCriteria.salesAgentFees) {
        res += Number(this.loanCriteria.salesAgentFees);
      }
      if (this.loanCriteria.purchaseLegalFees) {
        res += Number(this.loanCriteria.purchaseLegalFees);
      }

      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        if (this.loanCriteria.landTotalOtherCosts) {
          res += Number(this.loanCriteria.landTotalOtherCosts);
        }
      }

      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
        if (this.loanCriteria.purchaseCosts) {
          res += Number(this.loanCriteria.purchaseCosts);
        }
      }

      return res;
    }
  }

  isSelectedResult(offer: LenderResultSummaryDTO, index: number) {
    return this.comparisonContains(offer);
  }

  isResultAvailableToSelect(offer: LenderResultSummaryDTO) {
    return offer.isCaseLender && offer.caseLenderStatus != CaseLenderStateEnum.Shortlisted;
  }

  contingencyChanged() {
    this.calculateContingency();
  }

  updateLoanRequiredValue() {
    if (this.loanCriteria.maxLoanRequired) {
      this.loanCriteria.netLoanRequired = 0;
      this.updateSearchViaSlider();
    } else {
      this.updateSearchViaSlider();
    }
  }

  calculateContingency() {
    if (this.loanCriteria.includesContingency) {
      this.contingencyValue =
        this.loanCriteria.buildCosts - this.loanCriteria.buildCosts / (1 + Number(this.loanCriteria.contingency));
    }
    this.calculateTotalBuildCost();
  }

  calculateTotalBuildCost() {
    if (this.loanCriteria.includesContingency) {
      this.loanCriteria.buildCosts = Number(this.loanCriteria.buildCosts) - this.contingencyValue;
    }

    this.updateSearchViaSlider();
  }

  getRegionByPostcode() {
    if (this.loanCriteria.postcodeSearchString && this.loanCriteria.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.loanCriteria.postcodeSearchString)) {
        this.showPostcodeErrorMessage = false;
        this.isPostcodeChange = true;
        this.updateSearchViaSlider();
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
      }
    }
  }

  calculateMonthsSinceOrigPurchase() {
    let date1 = new Date(this.loanCriteria.originalPurchaseDate);
    let date2 = new Date();
    let months;
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months;
  }

  sortByField(field) {
    this.loanCriteria.sortBy = field;
    this.loadingData = true;
    this.developmentFinanceDealCrudClient
      .patch({
        id: this.loanCriteria.id,
        sortBy: this.loanCriteria.sortBy,
      })
      .then(() => {
        this.sortSummaryResults();
      })
      .finally(() => {
        this.loadingData = false;
      });
    this.showSortBy = !this.showSortBy;
  }

  sortSummaryResults() {
    const hasSortOrder = this.loanCriteria.sortOrder !== SortOrderEnum.None;
    const orderMultiplier = this.loanCriteria.sortOrder === SortOrderEnum.Descending ? -1 : 1;

    switch (this.loanCriteria && this.loanCriteria.sortBy) {
      case SortByEnum.ROCE:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.roce - b.roce) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => b.roce - a.roce || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.ProfitOnCost:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) =>
                (a.profitPercOfTotalCost - b.profitPercOfTotalCost) * orderMultiplier ||
                a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => b.profitPercOfTotalCost - a.profitPercOfTotalCost || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.TrueMonthlyCost:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.trueMonthlyCost - b.trueMonthlyCost) * orderMultiplier
            : (a, b) => a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.NetLoanSize:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.netLoan - b.netLoan) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => b.netLoan - a.netLoan || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.LenderName:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) =>
                a.loanLabel.localeCompare(b.loanLabel) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.loanLabel.localeCompare(b.loanLabel) || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.InterestRate:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.annualInterest - b.annualInterest) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.annualInterest - b.annualInterest || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.ArrangementFee:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.arrangementFee - b.arrangementFee) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.arrangementFee - b.arrangementFee || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.DepositEquity:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.deposit - b.deposit) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.deposit - b.deposit || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.LTGDV:
        this.lenderResultClient
          .sortProductsByLTGDV(this.summarySearchResults, this.loanCriteria.sortOrder)
          .then((sortedResults) => {
            this.summarySearchResults = sortedResults;
            // Assign row numbers after async sort
            this.summarySearchResults.forEach((item, index) => {
              item.selectedRowNumber = index + 1;
            });
          })
          .catch((error) => {
            console.error("Error sorting by LTGDV:", error);
          });
        return; // Exit early to avoid reassigning row numbers again

      default:
        if (!this.summarySearchResults) return;

        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.netLoan - b.netLoan) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => {
                if (a.netLoan < b.netLoan) return 1;
                if (a.netLoan > b.netLoan) return -1;
                if (a.trueMonthlyCost > b.trueMonthlyCost) return 1;
                if (a.trueMonthlyCost < b.trueMonthlyCost) return -1;
                return 0;
              },
        );
        this.loanCriteria.sortBy = SortByEnum.NetLoanSize;
    }

    // Assign a default sortOrder when None
    if (this.loanCriteria.sortOrder === SortOrderEnum.None) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.ROCE:
        case SortByEnum.NetLoanSize:
        case SortByEnum.ProfitOnCost:
          this.loanCriteria.sortOrder = SortOrderEnum.Descending;
          break;
        case SortByEnum.TrueMonthlyCost:
        case SortByEnum.LenderName:
        case SortByEnum.InterestRate:
        case SortByEnum.ArrangementFee:
        case SortByEnum.DepositEquity:
          this.loanCriteria.sortOrder = SortOrderEnum.Ascending;
          break;
        default:
          this.loanCriteria.sortOrder = SortOrderEnum.Descending;
      }
    }

    // Assign row numbers
    for (let i = 0; i < this.summarySearchResults.length; i++) {
      this.summarySearchResults[i].selectedRowNumber = i + 1;
    }
  }

  isFieldZero(fieldName) {
    if (this.loanCriteria) {
      const fieldValue = this.loanCriteria[fieldName];
      if (fieldValue == null || fieldValue === "0" || fieldValue === 0) {
        return true;
      }
    }

    return false;
  }

  submitLenderReferral() {
    this.loadingData = true;
    this.lenderReferralData.dealId = this.loanCriteria.id;
    this.dealClientClient
      .submitLenderReferral(this.lenderReferralData)
      .then((response) => {
        if (response) {
          this.displayMsg = "Your referral has been submitted.";
          this.showMsg = true;
          this.isLenderReferredSearch = true;
        } else {
          this.displayMsg = "Error while making a referral, please try later.";
          this.showMsg = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
        this.lenderReferralData = null;
        sessionStorage.removeItem("lenderReferralReference");
      });
  }

  onClickSaveAs() {
    this.isSaveAsClicked = true;

    if (this.isAdmin || this.isBroker) {
      if (!this.shareDealDto) {
        this.shareDealDto = {
          isApplicant: true,
          isPrimary: true,
        } as ShareDealDTO;
      }
      this.shareDealDto.dealName = "";
      this.showShareSearchModal();
    } else {
      this.showSaveResults = 3;
    }
  }

  reloadPage() {
    if (this.reloadSearch) {
      window.location.reload();
    }
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  // Enterprise widget
  openRegisterModal() {
    if (window.self == window.top && this.$cookies.get("access_token")) {
      this.reloadSearch = true;
      this.reloadPage();
    } else {
      this.showRegisterModal = true;
    }
  }

  onEditSearchNameClick() {
    this.toggleEditSearchName = !this.toggleEditSearchName;
  }

  /*onClickEligibleConfirm() {
    this.loadingData = true;
    this.loanCriteria.dealClients[0].Client.PhoneNumber =
      this.enterpriseClient.PhoneNumber;
    this.clientService
      .addUpdatereturnonlyid(this.loanCriteria.dealClients[0].Client)
      .then((response) => {
        this.showEligibleModal = false;
        window.scrollTo(0, 0);
      })
      .finally(() => {
        this.loadingData = false;
      });
  }*/

  onSortbyClick() {
    this.closeFilterOptions();
    this.closeExportDropdown();
    this.showSortBy = !this.showSortBy;
  }

  onFilterClick() {
    this.closeSortByDropdown();
    this.closeExportDropdown();
    this.showFilters = !this.showFilters;
  }

  onExportClick() {
    this.prepareDataForShortlistPdf();
    this.closeSortByDropdown();
    this.closeFilterOptions();
    this.showExportOptions = !this.showExportOptions;
  }

  getSelectedSortByOptionText() {
    if (this.loanCriteria) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.TrueMonthlyCost:
          return "True Monthly Cost";
        case SortByEnum.NetLoanSize:
          return "Net Loan Size";
        case SortByEnum.LenderCosts:
          return "Lender Costs (Est.)";
        case SortByEnum.LenderName:
          return "Lender Name (A-Z)";
        case SortByEnum.InterestRate:
          return "Interest Rate";
        case SortByEnum.ArrangementFee:
          return "Arrangement Fee";
        case SortByEnum.DepositEquity:
          return "Est. Deposit/Equity";
        case SortByEnum.ROCE:
          return "ROCE";
        case SortByEnum.LTGDV:
          return "LTGDV";
        case SortByEnum.ProfitOnCost:
          return "Profit on Cost";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  createAccount() {
    this.loadingData = true;
    this.enterpriseClient.orgUniqueRef = this.brokerageOrg.uniqueRef;
    this.enterpriseClient.name = this.enterpriseClient.email;
    this.enterpriseClient.oidcId = this.enterpriseClient.email;
    this.userClient
      .registerEnterpriseUserAndSaveShortlisteResults({
        enterpriseUser: this.enterpriseClient,
        shortlistedResults: this.getDealLenders(this.comparisonList),
        password: this.password,
        dealUniqueRef: this.toggleEditSearchName ? this.loanCriteria.uniqueRef : "",
        newDealName: this.toggleEditSearchName ? this.loanCriteria.name : "",
      })
      .then((user) => {
        // clean up session storage
        if (window.self == window.top) {
          sessionStorage.removeItem("clientId");
          sessionStorage.removeItem("userRole");
        } else {
          this.organisationService.sendDataToParent("clientId", "");
          this.organisationService.sendDataToParent("userRole", "");
        }
        this.login("ENTERPRISE-LEAD-REGISTERED-FROM-RESULTS-PAGE", EventLogEnum.EnterpriseUserRegistration);
      })
      .catch((response) => {
        this.error = "Error while registering an account, please try again later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  login(
    eventIdentifier: string = "ENTERPRISE-CONTACT-LOGGEDIN-FROM-RESULTS-PAGE",
    eventType: EventLogEnum = EventLogEnum.EnterpriseUserLogin,
  ) {
    this.loadingData = true;
    if (!this.$cookies.get("access_token")) {
      this.$auth
        .newLogin(this.enterpriseClient.userName, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
        .then((response) => {
          let expiry: Date = response;
          this.error = "";
          this.eventLogClient.logEvent(
            eventIdentifier,
            eventType,
            this.loanCriteria.productType,
            this.loanCriteria.id,
            "",
            "",
            this.loanCriteria.dealClients[0]?.client.id,
          );

          this.$rootScope.$broadcast("login"); //tell everyone you have logged in
          if (eventType == EventLogEnum.EnterpriseUserRegistration)
            sessionStorage.setItem("showConfirmClientPhoneNo", "true");
          this.$location.path(`/devfinanceresults/${this.loanCriteria.id}`);
        })
        .catch((response) => {
          this.isLoginError = true;
        })
        .finally(() => {
          this.loadingData = false;
        });
    }
  }

  onClickLogin() {
    this.saveShortlistedLenders();
    this.login();
  }

  saveShortlistedLenders() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: null,
      bridgingShortlistedResults: this.comparisonList,
      devFinanceShortlistedResults: null,
    } as ShortlistRequest;
    this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {});
  }

  returnShortlistedDealLenderStatusText(item: LenderResultSummaryDTO) {
    if (this.checkDeletedLender(item.lenderID, item.productID)) {
      return "Previously Deleted";
    }

    if (
      item.isDealLender &&
      this.loanCriteria.status != CaseStatusEnum.Search &&
      this.loanCriteria.status != CaseStatusEnum.NewCase &&
      this.loanCriteria.status != CaseStatusEnum.ReadyToSubmit
    ) {
      switch (item.dealLenderStatus) {
        case CaseLenderStateEnum.Shortlisted:
          return "Shortlisted";
        case CaseLenderStateEnum.Received:
          return "Awaiting DIP";
        case CaseLenderStateEnum.Offered:
          return "DIP Received";
        case CaseLenderStateEnum.Rejected:
          return "Lender Rejected";
        case CaseLenderStateEnum.Withdrawn:
          return "Lender Withdrawn";
        case CaseLenderStateEnum.Applied:
          return "DIP Accepted";
        case CaseLenderStateEnum.Cancelled:
          return "Cancelled";
        default:
          break;
      }
    }
  }

  isProceedButtonDisabled(): boolean {
    if (this.isShortlistingMore) {
      if (this.validateWithdrawnLendersUnique() == false) return true;
    }

    const validLenders =
      this.comparisonList?.filter(
        (item) =>
          item.dealLenderStatus !== CaseLenderStateEnum.Rejected &&
          item.dealLenderStatus !== CaseLenderStateEnum.Withdrawn,
      ) || [];

    if (
      !validLenders ||
      validLenders.length < 1 ||
      validLenders.length > this.noOfShortlistAllowed ||
      this.isProceedClicked == true
    ) {
      return true;
    }

    return false;
  }

  onSaveClick() {
    if (this.isAssigned) {
      this.isSaveorSaveAsClicked = true;
      this.register(false, this.productResultList);
    } else {
      this.showShareSearchModal();
    }
  }

  getProductLastVerifiedDates(productIds: (number | null)[]) {
    productIds = productIds.filter((item) => item !== null);
    this.productClient.getLastVerifiedDates(productIds).then((response) => {
      productIds.forEach((id) => {
        if (response[id] != null) {
          this.productLastVerifiedDates[id] = this.formatDate(response[id]);
        }
      });
    });
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  validateWithdrawnLendersUnique(): boolean {
    if (this.isShortlistingMore) {
      const matchingHiddenDeallender = this.HiddenDealLenderList.filter(
        (dl) =>
          this.comparisonList.some(
            (l) =>
              dl.lenderId === l.lenderID &&
              dl.productId != l.productID &&
              l.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
          ) && dl.status == CaseLenderStateEnum.Withdrawn,
      );

      const matchingDeallender = this.dealLenders?.filter(
        (dl) =>
          this.comparisonList.some(
            (l) =>
              dl.lenderId === l.lenderID &&
              dl.productId != l.productID &&
              l.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
          ) && dl.status == CaseLenderStateEnum.Withdrawn,
      );

      if (matchingHiddenDeallender.length > 0 || (matchingDeallender && matchingDeallender.length > 0)) return false;
    }

    return true;
  }

  closeFilterOptions() {
    this.showFilters = false;
  }

  closeSortByDropdown() {
    this.showSortBy = false;
  }

  closeExportDropdown() {
    this.showExportOptions = false;
  }

  updateClientContactInfoAndNotifyBroker() {
    if (this.loanCriteria != null && this.loanCriteria.dealClients != null) {
      this.dealClientClient
        .updateClientContactInfoAndNotifyBroker(
          this.clientUpdatedContact,
          this.loanCriteria?.id,
          this.loanCriteria.dealClients[0].client.id,
        )
        .then((response) => {
          this.showClientPhoneNumberConfirmationModal = false;
          this.sliderShown = true;
        })
        .catch((response) => {
          this.error = "There was an error updating the contact. Please try again later.";
        })
        .finally(() => {
          sessionStorage.removeItem("showConfirmClientPhoneNo");
        });
    } else {
      sessionStorage.removeItem("showConfirmClientPhoneNo");
      this.showClientPhoneNumberConfirmationModal = false;
      this.sliderShown = true;
    }
  }

  getOrgName() {
    if (this.orgName) {
      return this.orgName.replace(/_/g, " ");
    }
    return "";
  }

  /**Sends an email to the email address for the user to reset their password */
  sendResetPasswordEmail() {
    this.loadingData = true;
    this.userClient
      .resetForgottenPassword(this.enterpriseClient.email)
      .then((response) => {
        this.isLoginError = false;
        this.isResetPasswordSubmitted = true;
        this.registrationLoginError = null;
      })
      .catch((error) => {
        this.registrationLoginError = "There was an error sending the password reset email. Please try again later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  validateAccessAndRedirect() {
    //Do not allow the connect user to access the deal
    if (this.loanCriteria.isReferredToConnect && this.isConnectUser) {
      this.$location.path(`/devfinancecasedashboard/${this.loanCriteria.id}`);
    } else {
      if (
        this.loanCriteria.status != CaseStatusEnum.NewCase &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        !this.isShortlistingMore
      ) {
        this.dealLenderClient.fetchDealLendersByDealId(this.loanCriteria.id).then((results) => {
          if (
            results &&
            results.filter(
              (dl) =>
                !dl.isDeleted &&
                dl.status != CaseLenderStateEnum.Withdrawn &&
                dl.status != CaseLenderStateEnum.Rejected,
            ).length >= 5 &&
            results.filter((dl) => !dl.isDeleted && dl.isBidAccepted)
          ) {
            if (this.isAdmin || this.isBroker) {
              this.$location.path("/dealforum/" + this.loanCriteria.id);
            } else {
              this.$location.path(`/userdashboard`);
            }
          } else {
            this.$location.path(`/devfinanceshortlistmore/${this.loanCriteria.id}`);
          }
        });
      }
    }
  }

  flagIncorrectRateOrCriteria() {
    this.loadingData = true;

    const formatCurrency = (value) => "£" + this.$filter("number")(value, 0);
    const formatPercent = (value) => this.$filter("number")(value * 100, 2) + "%";

    const {
      lenderName,
      annualInterest,
      arrangementFee,
      exitFee,
      grossLoan,
      netLoan,
      deposit,
      trueMonthlyCost,
      roce,
      buildLoan,
      landLoan,
      profit,
    } = this.flaggedOffer;

    const equityOrDepositText = this.loanCriteria.ownOrPurchase === OwnOrPurchaseEnum.Own ? "Equity" : "Deposit";

    const resultsText = `
      <ul>
        <li>${lenderName}</li>
        <li>${formatPercent(annualInterest)} interest · ${formatPercent(
          arrangementFee,
        )} arrangement fee · ${formatPercent(exitFee)} exit fee</li>
        <li>Gross loan: ${formatCurrency(grossLoan)}</li>
        <li>Net loan: ${formatCurrency(netLoan)}</li>
        <li>Build loan: ${formatCurrency(buildLoan)}</li>
        <li>Land loan: ${formatCurrency(landLoan)}</li>
        <li>Cost (TMC): ${formatPercent(trueMonthlyCost)}</li>
        <li>${equityOrDepositText}: ${formatCurrency(deposit)}</li>
        <li>Profit: ${formatCurrency(profit)}</li>
        <li>ROCE: ${formatPercent(roce)}</li>
      </ul>
    `;

    const request = {
      resultsText: resultsText,
      dealId: this.loanCriteria.id,
      additionalDetails: this.flaggingDetails,
      incorrectDataType: this.incorrectDataType,
    } as FlagIncorrectRateOrCriteriaRequest;

    this.dealClient
      .flagIncorrectRateOrCriteria(request)
      .then(() => {
        this.setFlaggedSuccessMessage(
          `Incorrect ${this.incorrectDataType == IncorrectDataTypeEnum.Rate ? "rate" : "criteria"} flagged for review.`,
        );
        this.$timeout(() => {
          this.setFlaggedSuccessMessage("");
        }, 3000);
      })
      .catch(() => {
        this.setFlaggedSuccessMessage("Error while submitting, please try later.");
        this.$timeout(() => {
          this.setFlaggedSuccessMessage("");
        }, 3000);
      })
      .finally(() => {
        this.loadingData = false;
        this.flaggingDetails = "";
        this.showFlaggingModal = false;
      });
  }

  onFlaggingOptionSelected(offer, index, incorrectDataType: IncorrectDataTypeEnum) {
    this.showFlaggingModal = true;
    this.flaggedOffer = offer;
    this.showFlaggingOptions[index] = false;
    this.incorrectDataType = incorrectDataType;
  }

  onSortOrderClick() {
    this.loadingData = true;

    this.loanCriteria.sortOrder =
      this.loanCriteria.sortOrder === SortOrderEnum.Ascending ? SortOrderEnum.Descending : SortOrderEnum.Ascending;

    this.developmentFinanceDealCrudClient
      .patch({
        id: this.loanCriteria.id,
        sortOrder: this.loanCriteria.sortOrder,
      })
      .then(() => {
        this.sortSummaryResults();
      })
      .finally(() => {
        this.loadingData = false;
      });
  }
}
